export function getDaysInMonth(month, year) {
  const date = new Date(year, month, 0);
  const monthName = date.toLocaleDateString('pt-BR', {
    month: 'short',
  });
  const daysInMonth = date.getDate();
  const days = [];
  let i = 1;
  while (days.length < daysInMonth) {
    days.push(`${monthName} ${i}`);
    i += 1;
  }
  return days;
}

export function getHours() {
  const clock = []
  for (let i = 0; i < 24; i++)
    clock.push((i + ":00").padStart(5, "0"));
  return clock;
}

export function getFilterConfig(filter) {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  switch (filter) {
    case 'ONE_DAY': {
      const labels = [];
      const currentHour = now.getHours();

      for (let i = 23; i >= 0; i--) {
        let hour = currentHour - i;
        let day = 0;

        if (hour < 0) {
          hour += 24;
          day = -1;
        }

        const date = new Date(now);
        date.setDate(date.getDate() + day);
        date.setHours(hour, 0, 0, 0);

        const dayLabel = date.getDate();
        const monthName = date.toLocaleDateString('pt-BR', { month: 'short' });
        const hourLabel = hour.toString().padStart(2, '0') + ':00';

        labels.push(`${monthName} ${dayLabel} ${hourLabel}`);
      }

      return { length: 24, labels };
    }

    case 'SEVEN_DAYS': {
      const labels = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(now);
        date.setDate(date.getDate() - i);
        const monthName = date.toLocaleDateString('pt-BR', { month: 'short' });
        labels.push(`${monthName} ${date.getDate()}`);
      }
      return { length: 7, labels };
    }

    case 'ONE_MONTH': {
      const labels = [];
      for (let i = 29; i >= 0; i--) {
        const date = new Date(now);
        date.setDate(date.getDate() - i);
        const monthName = date.toLocaleDateString('pt-BR', { month: 'short' });
        labels.push(`${monthName} ${date.getDate()}`);
      }
      return { length: 30, labels };
    }

    case 'THREE_MONTHS': {
      const labels = [];
      for (let i = 2; i >= 0; i--) {
        const date = new Date(currentYear, currentMonth - 1 - i, 1);
        const monthName = date.toLocaleDateString('pt-BR', { month: 'short' });
        labels.push(monthName.charAt(0).toUpperCase() + monthName.slice(1));
      }
      return { length: 3, labels };
    }

    case 'SIX_MONTHS': {
      const labels = [];
      for (let i = 5; i >= 0; i--) {
        const date = new Date(currentYear, currentMonth - 1 - i, 1);
        const monthName = date.toLocaleDateString('pt-BR', { month: 'short' });
        labels.push(monthName.charAt(0).toUpperCase() + monthName.slice(1));
      }
      return { length: 6, labels };
    }

    case 'ONE_YEAR': {
      const labels = [];
      for (let i = 12; i >= 0; i--) {
        const date = new Date(currentYear, currentMonth - 1 - i, 1);
        const monthName = date.toLocaleDateString('pt-BR', { month: 'short' });
        const year = date.getFullYear().toString().slice(-2);
        labels.push(`${monthName.charAt(0).toUpperCase() + monthName.slice(1)}. ${year}`);
      }
      return { length: 13, labels };
    }

    default: {
      const labels = [];
      for (let i = 4; i >= 0; i--) {
        labels.push((currentYear - i).toString());
      }
      return { length: 5, labels };
    }
  }
}
